import WORK_DIALOG_SIZES from "@/components//base_components/dialog/components/enums/WORK_DIALOG_SIZES";

export default {
    props: {
        path: { type: String },
        headers: { type: Array },
        mandatoryFilters: undefined,
        filterPreset: { type: Object },
        responseDialogData: { type: Function, default: undefined },
        excludeIds: { type: Array, required: false },
        withSelection: { type: Boolean, default: false },
        selection: { type: [Array, Object], default: () => [] },        
        addUniqueIdentifier: { type: Boolean, default: false},
        withCart: { type: Boolean, default: false},
        width: { type: String, default: WORK_DIALOG_SIZES.EXTRA_LARGE },
        formatCartLabel: { type: Function, default: (item) => item.label},
        selectId: { type: Boolean }
    },
}
